import React, {Component} from 'react'
import {Grid, Row, Col} from 'react-flexbox-grid'

import JobListing from './JobListing'

import ReactGA from 'react-ga';
ReactGA.initialize('UA-110112779-1');
ReactGA.pageview(window.location.pathname + window.location.search);

var Parse = require('parse');
var _ = require('underscore')
export default class Jobs extends Component {

  constructor(props){
    super(props)

    Parse.initialize(process.env.REACT_APP_API_KEY)
    Parse.serverURL = process.env.REACT_APP_API_URL

    this.state = {
      jobs: [],
      loading: true,
    }

  }

  componentWillMount(){
    this.getJobInfo()
  }

  getJobInfo(){
    let thisState = this
    let query = new Parse.Query('JobType')
    query.find().then(jobTypes => {
      _.each(jobTypes, jobType => {
        let job = {type:jobType, roles:[]}
        let rolesRelation = jobType.relation("job_roles")
        rolesRelation.query().find().then(fetchedRoles => {
            _.each(fetchedRoles, fetchedRole => {
              if (fetchedRole.get('filled') === false){
                job.roles.push(fetchedRole)
                thisState.updateJobs(job)
              }
            })
        })
      })
    }).catch(error => {
      console.error(error);
    })
    this.setState({loading:false})
  }

  updateJobs(job){
    let type = <h1 key={job.type.id}>{job.type.get("name")}</h1>
      let sortedRoles = job.roles.sort(function(a, b){
       if(a.get("title") < b.get("title")) return -1;
       if(a.get("title") > b.get("title")) return 1;
       return 0;
     })
    let roles = sortedRoles.map(role => {
      return <JobListing key={role.id} id={role.id} title={role.get("title")} location={role.get("location")}/>
    })

    let typeAndRoles = <div>{type}{roles}</div>
    this.setState({jobs:typeAndRoles})
  }

  render(){
    return(
      <Grid>
        <Row center='xs'>
          <Col xs={10}>
            <h1 className='notExistHeader'>Jobs</h1>
            <p>The people here at UniversityGO are leading the way for the next generation of students. We consider ourselves students too, since we're always learning how to sharpen our own skills and expertise. Take a look at how you can join our team by viewing our opportunities below.</p>
          </Col>
        </Row>
        <Row left='xs'>
          <Col xs={10}>
            {this.state.loading ? <p>Loading...</p> : null}
            {this.state.jobs}
          </Col>
        </Row>
      </Grid>
    )
  }
}



// WEBPACK FOOTER //
// ./src/Views/Jobs/Jobs.js